document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initSelectorVariantes();
  initSelectorPacks();
  initContador();
  initTilt();
  initParallax();
});

function initTilt() {
  if (window.matchMedia('(hover: none)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var els = document.querySelectorAll('.mt-tilt');
  els.forEach(function (el) {
    var strength = Number(el.getAttribute('data-mt-tilt-fuerza')) || 10;
    el.addEventListener('mousemove', function (e) {
      var rect = el.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      el.style.transform = 'perspective(900px) rotateY(' + (x * strength) + 'deg) rotateX(' + (-y * strength) + 'deg)';
    });
    el.addEventListener('mouseleave', function () {
      el.style.transform = 'perspective(900px) rotateY(0deg) rotateX(0deg)';
    });
  });
}

function initParallax() {
  var els = document.querySelectorAll('.mt-parallax');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.innerWidth < 768) return;
  var ticking = false;
  function update() {
    els.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var vh = window.innerHeight;
      var progress = (vh - rect.top) / (vh + rect.height);
      progress = Math.min(Math.max(progress, 0), 1);
      var range = Number(el.getAttribute('data-mt-parallax-rango')) || 40;
      var shift = (progress - 0.5) * range;
      el.style.transform = 'translateY(' + shift + 'px)';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  update();
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal--scale');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-mt-delay') || 0;
        setTimeout(function () { entry.target.classList.add('mt-visible'); }, Number(delay));
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var main = document.querySelector('[data-mt-galeria-principal]');
  if (!main) return;
  var thumbs = document.querySelectorAll('[data-mt-galeria-thumb]');
  var opcionSelect = document.querySelector('[data-mt-opcion]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var url = thumb.getAttribute('data-mt-full');
      main.src = url;
      thumbs.forEach(function (t) { t.classList.remove('mt-thumb-activa'); });
      thumb.classList.add('mt-thumb-activa');
      var variantNombre = thumb.getAttribute('data-mt-variant-nombre');
      if (variantNombre && opcionSelect) {
        opcionSelect.value = variantNombre;
        opcionSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
}

function initSelectorVariantes() {
  var form = document.querySelector('[data-mt-form-producto]');
  if (!form) return;
  var dataEl = document.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variants = JSON.parse(dataEl.textContent);
  var selects = form.querySelectorAll('[data-mt-opcion]');
  var idInput = form.querySelector('[data-mt-id-input]');
  var priceEl = document.querySelector('[data-mt-precio]');
  var compareEl = document.querySelector('[data-mt-precio-comparado]');
  var submitBtn = form.querySelector('[data-mt-submit]');

  function currentSelection() {
    var values = [];
    selects.forEach(function (sel) { values.push(sel.value); });
    return values;
  }

  function findVariant(values) {
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === values[i]; });
    });
  }

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function update() {
    var variant = findVariant(currentSelection());
    if (!variant) return;
    idInput.value = variant.id;
    if (priceEl) priceEl.textContent = moneyFormat(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = moneyFormat(variant.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
    if (submitBtn) {
      if (variant.available) {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.getAttribute('data-mt-texto-disponible');
      } else {
        submitBtn.disabled = true;
        submitBtn.textContent = submitBtn.getAttribute('data-mt-texto-agotado');
      }
    }
  }

  selects.forEach(function (sel) { sel.addEventListener('change', update); });
  update();
}

function initSelectorPacks() {
  var packsWrap = document.querySelector('[data-mt-packs]');
  if (!packsWrap) return;
  var packs = packsWrap.querySelectorAll('[data-mt-pack]');
  var quantityInput = document.querySelector('[data-mt-quantity-input]');
  var opcionSelects = document.querySelectorAll('[data-mt-opcion]');

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function currentUnitPriceCents() {
    var priceEl = document.querySelector('[data-mt-precio]');
    if (!priceEl) return 0;
    var value = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ''));
    return Math.round(value * 100);
  }

  function refreshPrices() {
    var unit = currentUnitPriceCents();
    packs.forEach(function (pack) {
      var cantidad = Number(pack.getAttribute('data-mt-cantidad'));
      var precioEl = pack.querySelector('[data-mt-pack-precio]');
      var tachadoEl = pack.querySelector('[data-mt-pack-precio-tachado]');
      if (cantidad === 1) {
        if (precioEl) precioEl.textContent = moneyFormat(unit);
      } else if (tachadoEl) {
        tachadoEl.textContent = moneyFormat(unit * cantidad);
      }
    });
  }

  function setActive(selected) {
    packs.forEach(function (pack) {
      var isActive = pack === selected;
      pack.classList.toggle('mt-pack-activo', isActive);
      pack.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    if (quantityInput) quantityInput.value = selected.getAttribute('data-mt-cantidad');
  }

  packs.forEach(function (pack) {
    pack.addEventListener('click', function () { setActive(pack); });
  });

  opcionSelects.forEach(function (sel) {
    sel.addEventListener('change', refreshPrices);
  });

  refreshPrices();
}

function initContador() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseInt(el.getAttribute('data-mt-contador'), 10) || 0;
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        el.textContent = Math.floor(progress * target).toLocaleString('es-ES');
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target.toLocaleString('es-ES');
      }
      requestAnimationFrame(step);
      observer.unobserve(el);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { observer.observe(el); });
}
